import FORMFIELD from '../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import SELECT from '../../../../../../DOM/form/fieldset/field/select/SELECT.js';
import { labelModel } from '../../../../../../DOM/form/label/LABEL.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { fieldModel } from '../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../DOM/span/SPAN.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const formSelectAttr = makeAttrStruct([
    ['class']
]);
export const formSelectData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formSelectModel = makeStruct([
    ['attributes', formSelectAttr],
    ['data', formSelectData]
]);
// Simplified Model
export function formSelect(label, field, message, buttons) {
    return {
        attributes: formSelectAttr(),
        data: formSelectData(label, field, message, buttons)
    };
}
/** Represents a <SELECT> for a FORM Element */
export default class FORMSELECT extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
        this.addClass('form-select');
        if (model.attributes.multiple) {
            this.getField().setAttribute('multiple', 'true');
        }
        else {
            this.getField().removeAttribute('multiple');
        }
    }
    createField(model) {
        return new SELECT(this, model);
    }
}
